"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function apply(f, args) {
    if (args === undefined) {
        return function (args) { return f.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false)); };
    }
    else {
        return f.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
    }
}
exports.default = apply;
//# sourceMappingURL=apply.js.map